import React from 'react'
import { DataGridPro, DataGridProProps, GridColDef, GridFilterModel, GridRowSpacingParams, useGridApiRef } from '@mui/x-data-grid-pro'
import type { } from "@mui/x-data-grid/themeAugmentation";
import { SxProps, Theme, alpha, useTheme } from '@mui/material';
import { ExpandLess, ExpandMore } from '@mui/icons-material';
import { IShopOutcome } from '../pick6/store/types';



//BDK FUTURE Update this interface to only have sx and not two versions so it matches the MUI library standard
interface OwnProps {
  readonly data: IShopOutcome[];
  readonly loading: boolean;
  readonly isMobile: boolean;
  readonly defaultSort: string;
  readonly columns: GridColDef<any>[];
  readonly mobileColumns: GridColDef<any>[];
  readonly tableProps?: Partial<DataGridProProps>;
  readonly sxMobile?: SxProps<Theme>;
  readonly sxDesktop?: SxProps<Theme>;
  readonly gridFilterModel?: GridFilterModel;
}

type Props = OwnProps;

const OSDataGrid = (props: Props) => {
  const {
    data,
    defaultSort,
    columns,
    mobileColumns,
    tableProps,
    isMobile,
    loading,
    sxMobile,
    sxDesktop,
  } = props;

  const theme = useTheme();

  const handleFilterModelChange = (model: GridFilterModel) => {
      // dispatch(setUserSettings({
      //   ...userSettings,
      //   gridFilterModelShop: model,
      // }));
      // dispatch(setGridFilterModelShop(model || defaultGridFilterModel));
  }

  //This object contains the default styling for OSDataGrid on mobile devices. 
  const mobileStyles: SxProps<Theme> = {
    border: 'none',
    "& .MuiDataGrid-cell:focus-within, & .MuiDataGrid-cell:focus": {
      outline: "none !important",
    },
    "& .MuiDataGrid-columnHeader:focus-within, & .MuiDataGrid-columnHeader:focus":
    {
      outline: "none !important",
    },
    "& .MuiDataGrid-row:hiddenBet": {
      opacity: 0.5,
      backgroundColor: 'rgba(0, 0, 0, 1) !important'
    },
    '& .hiddenBet': {
      opacity: 0.5,
      backgroundColor: 'rgba(0, 0, 0, 1) !important'
    },
    '& .MuiDataGrid-cell': {
      padding: 0,
      '&:focus': {
        outline: 'none',
      }
    },
    '& .MuiDataGrid-withBorderColor': {
      border: 'none',
    },
    '& .MuiDataGrid-virtualScroller::-webkit-scrollbar': {
      width: '0.2em',
    },
    '& .MuiDataGrid-virtualScroller::-webkit-scrollbar-track': {
      background: '#101010',
    },
    '& .MuiDataGrid-virtualScroller::-webkit-scrollbar-thumb': {
      backgroundColor: '#888',
    },
    '& .MuiDataGrid-virtualScroller::-webkit-scrollbar-thumb:hover': {
      background: '#555',
    },
    '& .MuiDataGrid-footerContainer': {
      justifyContent: 'center',
    }
  };

  //This object contains the default styling for OSDataGrid on desktop devices. 
  const desktopStyles: SxProps<Theme> = {
    color: 'white',
    height: '100%',
    border: 'none',
    borderRadius: '10px',
    backgroundColor: { md: '#1C1C1C' },
    '& .MuiDataGrid-virtualScroller': {
      overflowX: 'hidden',
    },
    '& .hiddenBet': {
      // opacity: 0.7,
      color: alpha(theme.palette.common.white, .3),
      backgroundColor: 'black !important'
    },
    '& .MuiDataGrid-virtualScroller::-webkit-scrollbar': {
      width: '8px',
      height: 14,
      padding: 8,

    },
    '& .MuiDataGrid-virtualScroller::-webkit-scrollbar-track': {
      background: 'transparent',
    },
    '& .MuiDataGrid-virtualScroller::-webkit-scrollbar-thumb': {
      backgroundColor: alpha(theme.palette.common.white, 0.15),
      borderRadius: 4,
      borderTop: '3px transparent solid',
      borderBottom: '3px transparent solid',
      backgroundClip: 'padding-box',
    },
    '& .MuiDataGrid-virtualScroller::-webkit-scrollbar-thumb:hover': {
      backgroundColor: alpha(theme.palette.common.white, 0.35),
      borderRadius: 4,
      borderTop: '3px transparent solid',
      borderBottom: '3px transparent solid',
      backgroundClip: 'padding-box',
    },
    '& .MuiDataGrid-sortIcon': {
      color: 'common.white',
    },
    '& .MuiDataGrid-columnSeparator': {
      color: alpha(theme.palette.common.white, .3),
    },
    '& .MuiDataGrid-row:nth-child(odd)': {
      backgroundColor: alpha('#101010', .5),
      '& .MuiDataGrid-row.Mui-hovered': {
        backgroundColor: alpha('#101010', .5),
      },
    },
    '& .MuiDataGrid-cellContent': {
      fontWeight: 400,
    },
    '& .MuiDataGrid-columnHeader': {
      backgroundColor: '#1C1C1C',
      color: alpha(theme.palette.common.white, 0.7),
      fontWeight: 700,
      fontSize: 12,
      padding: '10px 8px',
    },
    '& .MuiDataGrid-root': {
      border: 'none !important',
      borderRadius: '10px'
    },
    '& .MuiDataGrid-main': {
      border: 'none !important',
      borderRadius: '10px',
    },
    '& .osrating': {
      borderRadius: '6px 0px 0px 0px',
      background: 'linear-gradient(90deg, #00723B 0%, #004E28 100%)',
      '& .MuiDataGrid-columnHeaderTitle': {
        color: 'text.primary',
        fontWeight: 700,
      }
    },
    '& .MuiDataGrid-cell': {
      borderBottomWidth: 0,
      paddingTop: '8px',
      paddingBottom: '8px',
      '&:last-of-type': {
        borderRightWidth: 0,
      }
    },
    '& .osratingCell': {
      padding: 0,
    },
    '& .ev': {
      borderRadius: '0px 6px 0px 0px',
      background: 'linear-gradient(90deg, #004E28 0%, #002E18 100%)',
      '& .MuiDataGrid-columnHeaderTitle': {
        color: 'text.primary',
        fontWeight: 700,
      }
    },
    '& .evCell': {
      padding: 0,
    },
    "& .MuiDataGrid-row.Mui-hovered, .MuiDataGrid-row:hover": {
      backgroundColor: "rgba(255, 255, 255, 0.08) !important",
    },
    '& .MuiDataGrid-menuIcon': {
      '& button': {
        width: '1.5em',
        '& svg': {
          width: '1.5em',
        }
      }
    }
  };

  const mstyle = sxMobile ? sxMobile : mobileStyles;
  const dstyle = sxDesktop ? sxDesktop : desktopStyles;

  const apiRef = useGridApiRef();

  const getRowSpacing = React.useCallback((params: GridRowSpacingParams) => {
    return {
      bottom: 8,
    };
  }, []);

  return (
    <>
      {
        isMobile && (
          <>
            {/* <Box marginBottom="16px">
              <SelectComponent
                backgroundColorOverride={theme.palette.background.secondary}
                options={mobileColumns.filter(x => x.field).flatMap(x => [{ ...x, direction: 'desc' }, { ...x, direction: 'asc' }])}
                label={'Sort By'}
                getMenuItemLabel={(item) => `${item.headerName} - ${item.direction?.toUpperCase()}`}
                getValue={(item) => ({ field: item.field, direction: item.direction })}
                handleClick={handleSort}
              />
            </Box> */}
            <DataGridPro
              localeText={{
                toolbarFilters: "More Filters",
              }}
              apiRef={apiRef}
              columns={mobileColumns}
              rows={data || []}
              getRowId={(row) => row?.outcomeId}
              scrollbarSize={0}
              rowSelection={false}
              loading={loading}
              onFilterModelChange={(model) => handleFilterModelChange(model)}
              // hideFooter={true}
              columnHeaderHeight={0}
              getRowHeight={() => 'auto'}
              getRowSpacing={getRowSpacing}
              disableColumnMenu
              // sortModel={sortModel}
              onSortModelChange={(newSortModel) => console.log('newSort', newSortModel)}
              initialState={{
                sorting: {
                  sortModel: [{ field: defaultSort, sort: 'desc' }],
                },
                columns: {
                  columnVisibilityModel: {
                    // Hide columns status and traderName, the other columns will remain visible
                    oddsAmerican: false,
                    sev: false,
                    expectedRoiPct: false,
                    expectedWinPct: false,
                    userId: false,
                    trueOdds: false,
                    evAge: false,
                    offerName: false,
                    name: false,
                  },
                },
              }}
              sx={mstyle}
              {...tableProps}
            />
          </>
        )
      }
      {!isMobile && (
        <DataGridPro
          columns={columns}
          rows={data || []}
          getRowId={(row) => row?.outcomeId}
          showCellVerticalBorder
          scrollbarSize={0}
          rowSelection={false}
          loading={loading}
          columnHeaderHeight={isMobile ? 0 : 36}
          getRowHeight={() => 'auto'}
          slots={{
            treeDataExpandIcon: () => <ExpandMore />,
            treeDataCollapseIcon: () => <ExpandLess />,
          }}
          onFilterModelChange={(model) => handleFilterModelChange(model)}
          initialState={{
            sorting: {
              sortModel: [{ field: defaultSort, sort: 'desc' }],
            },
          }}
          sx={dstyle}
          {...tableProps}
        />
      )
      }
    </>
  )
}

export default OSDataGrid